import React from 'react'
import { withStyles } from '@material-ui/core'
import PlacesAutocomplete from 'react-places-autocomplete'
import PropTypes from 'prop-types'

const styles = theme => ({
  autocompleteDropdownContainer: {
    position: 'relative',
    zIndex: 1,
    borderRadius: '4px',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: '#1dbbb0',
    },
    '& li': {
      margin: '0',
      padding: '3px',
      height: '40px',
    },
    '& li > span': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: '0px',
      padding: '0 21px',
    },
  },
  suggestionLi: {
    width: '100%',
    height: '40px',
    display: 'block',
    lineHeight: '40px',
    padding: '0px 13px 0px 12px',
    margin: '0',
    borderRadius: '4px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: 'rgba(29, 187, 176, 0.13)',
      color: '#00bcb5',
    },
  },
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#00bcb5',
    },
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'black',
    },
  },
  cssLabelError: {
    '&$cssFocused': {
      color: 'red',
    },
  },
  cssFocused: {},
})

class LocationAutoComplete extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  createSuggestion(getSuggestionItemProps, suggestion) {
    const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
    const style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' }
    return (
      <div
        {...getSuggestionItemProps(suggestion, {
          className,
          style,
        })}>
        <span className={this.props.classes.suggestionLi}>{suggestion.description}</span>
      </div>
    )
  }

  render() {
    const { classes, location, index } = this.props
    let locationValue = location && location.length >= 21 ? location.slice(0, 21) + '...' : location
    return (
      <PlacesAutocomplete
        value={locationValue}
        searchOptions={{ types: ['(regions)'] }}
        onChange={this.props.locationSelection}
        onSelect={this.props.locationSelection}>
        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <div>
            {React.cloneElement(this.props.children, {
              ...getInputProps({
                id: index !== undefined ? 'location_' + index : 'location',
                label: 'INVESTMENT LOCATION',
                className: 'location-search-input',
              }),
            })}

            <div className={classes.autocompleteDropdownContainer}>
              {suggestions.map(suggestion => {
                return this.createSuggestion(getSuggestionItemProps, suggestion)
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    )
  }
}

LocationAutoComplete.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(LocationAutoComplete)



// WEBPACK FOOTER //
// ./src/components/LocationAutoComplete.js